var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"violation_contract"}},[_c('h5',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$t("contract.violation.headline")))]),_vm._v(" "),_c('p',{staticClass:"user-output"},[_vm._v("\n    "+_vm._s(_vm.$t("contract.violation.paragraphOne", { amount: _vm.amount }))+"\n  ")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t("contract.violation.paragraphTwo")))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t("contract.violation.paragraphThree")))]),_vm._v(" "),_c('hr')])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/hemmelig/components/contract/Violation.vue?vue&type=template&id=0bd066f2&
// module id = null
// module chunks = 